/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgVideoOff(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <g>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M.47.47a.75.75 0 011.06 0l4 4 18 18a.75.75 0 11-1.06 1.06l-5.815-5.814A2.749 2.749 0 0114 19.75H3A2.75 2.75 0 01.25 17V7A2.75 2.75 0 013 4.25h.19L.47 1.53a.75.75 0 010-1.06zm4.22 5.28H3A1.25 1.25 0 001.75 7v10A1.25 1.25 0 003 18.25h11A1.25 1.25 0 0015.25 17v-.69L4.69 5.75zM9.91 5a.75.75 0 01.75-.75H14A2.75 2.75 0 0116.75 7v3.03l.328.328 5.482-3.966A.75.75 0 0123.75 7v10a.75.75 0 01-1.5 0V8.468l-4.81 3.48a.75.75 0 01-.97-.078l-1-1a.75.75 0 01-.22-.53V7A1.25 1.25 0 0014 5.75h-3.34A.75.75 0 019.91 5z'
        />
      </g>
      <defs>
        <clipPath id='video-off_svg__clip0_126_10497'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgVideoOff;
